import { View, Text, StyleSheet } from "@react-pdf/renderer";

import { NullableNumber, ReportItemType } from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";

import { getNumberOfItemsText } from "../report/utils/reportString";
import { formatValueAndUnitBasedOnTypeInReport } from "../report/utils/reportFormat";

const overallTotalTextStyles = StyleSheet.create({
    overallCardTotalContainer: {
        width: '100%',
        fontFamily: 'Roboto',
        display: 'flex',
        flexDirection: 'row',
        marginTop: 10,
    },
    overallCardTotalFirstSection: {
        position: 'relative',
        fontFamily: 'Roboto',
    },
    overallCardTotalLabel: {
        fontFamily: 'Roboto',
        fontSize: 10,
        fontWeight: 400,
        color: '#636363',
    },
    overallCardTotalValue: {
        fontFamily: 'Roboto',
        fontSize: 14,
        fontWeight: 600,
        color: '#333333',
    },
});

type ReportPDFOverallTotalTextProps = {
    itemType: ReportItemType;
    numberOfItems: NullableNumber;

    total: NullableNumber;

    unit: string;

    color: string;
};

export default function ReportPDFOverallTotalText({
    itemType,
    numberOfItems,
    total,
    unit,
    color,
}: Readonly<ReportPDFOverallTotalTextProps>) {
    const totalDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, total, unit, false);
    let totalLabel = REPORT_SENSOR_REGISTRY[itemType].tabTotal;

    if (
        numberOfItems !== null &&
        (itemType === 'room' || itemType === 'energy' || itemType === 'water' || itemType === 'waterLeakage')
    ) {
        const numItemText = getNumberOfItemsText(numberOfItems, itemType);

        totalLabel = `${REPORT_SENSOR_REGISTRY[itemType].tabTotal}${numItemText}`;
    }

    return (
        <View style={overallTotalTextStyles.overallCardTotalContainer}>
            <View style={overallTotalTextStyles.overallCardTotalFirstSection}>
                <Text style={overallTotalTextStyles.overallCardTotalLabel}>
                    {totalLabel}
                </Text>
                <Text style={{ ...overallTotalTextStyles.overallCardTotalValue, color }}>
                    {`${totalDisplay}`}
                </Text>
            </View>
        </View>
    );
};
